var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.3875 0 0 22.3875 0 50C0 77.6125 22.3875 100 50 100C77.6125 100 100 77.6125 100 50C100 22.3875 77.6125 0 50 0ZM50 93.75C25.8789 93.75 6.25 74.1211 6.25 50C6.25 25.8789 25.8789 6.25 50 6.25C74.1211 6.25 93.75 25.8789 93.75 50C93.75 74.1211 74.1211 93.75 50 93.75ZM65.4664 32.3242L43.3719 54.4187L34.5336 45.5813C32.0922 43.1398 28.1313 43.1398 25.6953 45.5813C23.2539 48.0227 23.2539 51.9836 25.6953 54.4195L38.9523 67.6766C41.3875 70.118 45.3492 70.118 47.7906 67.6766L74.3047 41.1625C76.7461 38.7211 76.7461 34.7602 74.3047 32.3242C71.8688 29.8828 67.9078 29.8828 65.4664 32.3242Z",
    fill: "#0046FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.f1faa3422736a1f2a377883a5976f5bd.svg";
export { ForwardRef as ReactComponent };